import { createContext as o } from "react";
import t from "./atoms-v2122.js";
import { breakpoints as e } from "./atoms-v2125.js";
const r = {
  activeBreakpoints: {},
  colGap: void 0,
  columns: t(e, "max.columns")
}, n = o(r);
export {
  n as GridContext
};
